<template>
  <ion-page>
    <master-layout pageTitle="پیام های راسالی شما">
      <IonCardContent>
        <router-link to="/message/addNew" class="btn btn-info">ارسال پیام جدید</router-link>
        <DataTable ref="d_table" auto-reload="1" :card="true" v-if="route" :functions="functions" :headers="headers"
                   :route="route"></DataTable>
        <ModalComponent modal-title="جزئیات پیام" :is-open="isModalOpen" @close="isModalOpen = false">
          <div class="bg-white" v-if="message">
            <div class="space_between">
              <div>
                <i class="fal fa-file-signature"></i>&nbsp;
                <span>{{ message.title }}</span>
              </div>
              <div>
                <i class="fal fa-calendar-alt"></i>&nbsp;
                {{ message.created_date }}
              </div>
            </div>
            <div class="message" v-html="message.content"></div>
            <div v-if="message.files" style="margin-top: 10px">
              <label>فایل های پیوست : </label>
              <br>
              <div class="files">
                <template v-for="file in message.files" :key="file">
                  <a target="_blank" :href="file_url_prefix+file.name">
                    <img style="width: 60px;height: 60px" src="/assets/img/file-icon.png" alt="">
                  </a>
                </template>
              </div>


            </div>
          </div>
          <div v-else>
            <p>اطلاعات پیام یافت نشد.</p>
          </div>
        </ModalComponent>
      </IonCardContent>

    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "../../components/DataTable"

import {
  IonPage, IonCardContent, alertController
} from "@ionic/vue";
import {mapActions} from "vuex";
import ModalComponent from "@/components/ModalComponent.vue";
import {AppApi} from "@/api/AppApi";
import {showSystemNoti} from "@/shared/helper";


export default {
  data()
  {
    return {
      headers: [
        'عنوان',
        'تاریخ ایجاد',
        'ارسال کننده',
        'وضعیت',
        'امکانات',
      ],
      route:'Message/listAjax?just_send=1',
      file_url_prefix : '',
      isModalOpen: false,
      message: null,
      functions:[
        {name : 'showMsg',method: this.showMsg},
        {name : 'delMessage',method: this.delMessage},
      ],
    };
  },
  mounted()
  {
  },

  components: {
    ModalComponent,
    DataTable, IonPage,IonCardContent
  },
 methods:{
  async showMsg(id)
   {
     const result = await this.getMessage(id);
     if(result.ok)
     {
       this.file_url_prefix = result.file_url_prefix;
       this.message = result.message;
       this.isModalOpen = true;
     }
     this.getAndSaveMessageCount();
   },
   async delMessage(id)
   {
     console.log(id)
     return alertController
         .create({
           header: 'تایید حذف پیام',
           message: '<strong>اطمینان دارید پیام حذف شود؟</strong>!!!',
           buttons: [
             {
               text: 'لغو',
               role: 'cancel',
               cssClass: 'secondary',
             },
             {
               text: 'حذف',
               handler: () => {
                 this.confirmDeleteMessage(id);
               },
             },
           ],
         })
         .then(a => a.present())
   },
   async confirmDeleteMessage(id)
   {
     const result = await AppApi.deleteMessage(id);
     if (result.ok)
     {
       const table= this.$refs.d_table;
       table.reInit();
       return showSystemNoti('success',result.message);
     }
     else
       return showSystemNoti('danger',result.error);
   },
   ...mapActions('message',{
     getMessage:'getMessage',
   }),
   ...mapActions('app',{
     getAndSaveMessageCount:"getMessageCount"
   })
   }
}
</script>

<style scoped>
.space_between
{
  display: flex;
  justify-content: space-between;
}
.message{
  border: 1px solid silver;
  border-radius: 4px;
  padding: 7px;
  margin-top: 9px;
}
.bg-white
{
  background: white;
  color: black;
  padding: 10px;
}
.files
{
  display: flex;
  grid-gap: 10px;
  margin-top: 10px;
}
</style>